import UploadScreen from './UploadScreen';

export default UploadScreen;
